import { Box, useTheme } from "@mui/material"
import type { CSSProperties } from "react"
import { SearchIcon } from "./IconUrls"

type SearchNoResultIconProps = {
  size?: number | string
  color?: CSSProperties["color"]
}

export const SearchNoResultIcon = ({
  size = 56,
  color,
}: SearchNoResultIconProps) => {
  const { palette } = useTheme()
  const currentColor = color ?? palette.common.electricBlue
  const numericSize = Number(size)

  return (
    <Box width={size} height={size} position="relative">
      <Box
        component="svg"
        viewBox="0 0 57 55"
        width={"100%"}
        height={"100%"}
        color={`color-mix(in srgb, ${currentColor} 50%, transparent)`}
        sx={{ position: "absolute", inset: 0 }}
      >
        <use href="/icons/openXFolder.svg#openXFolder" />
      </Box>
      <SearchIcon
        color={currentColor}
        size={numericSize / 1.85}
        style={{
          position: "absolute",
          top: "35%",
          left: "-17%",
        }}
      />
    </Box>
  )
}
